import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { HttpService } from 'src/app/services/http.service';
import { LanguageService } from 'src/app/services/language.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ListFields } from '../../listfields';
import { RecalledComponent } from '../component';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-recalled-list',
  templateUrl: './recalled-list.component.html',
  styleUrls: ['./recalled-list.component.scss'],
  standalone: false
})
export class RecalledListComponent implements OnInit {

  /** Define field list for sorting and grouping */
  public recalledFields: ListFields[] = [
    { Id: 0, FieldName: "SerialNumber", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentRecalled_SN, SearchBy: true, GroupBy: true, SearchName: "serial" },
    { Id: 1, FieldName: "ComponentId", Uppercase: true, DisplayName: this.languageService.languageJSON.ComponentRecalled_ComponentId, SearchBy: true, GroupBy: true, SearchName: "component_id" },
    { Id: 2, FieldName: "OEMName", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentDetails_OEMName, SearchBy: true, GroupBy: true, SearchName: "oem_name" },
    { Id: 3, FieldName: "LastModification", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentRecalledUploads_LastModification, SearchBy: true, GroupBy: true, SearchName: "last_modification", DateInterval: true },
    { Id: 4, FieldName: "Recalled", Uppercase: false, DisplayName: this.languageService.languageJSON.ComponentRecalled_Recalled, SearchBy: false, GroupBy: true, SearchName: "recalled" },
  ];

  /** List view of the bike components */
  public recalledComponentList: any[] = [];
  public componentSearch: string = "";
  public searchByList: any = {};
  public loading: boolean = true;
  public componentClassOptionsList: { id: number, name: string }[] = [];
  public selectedComponentField: number = 0;
  public order: string = this.recalledFields[0].FieldName;
  public reverse: boolean = false;
  public caseInsensitive: boolean = true;
  public page: number = 1;
  public totalItems: number = 0;
  public itemsPerPage: number = this.settingsService.getItemsPerPage();
  public paginationValues: number[] = this.settingsService.getPaginationValues();
  private typeTimeoutRef: any;
  public markAsUnrecalled: boolean = false;
  public selectedElements: boolean = false;
  public selectAll: boolean = false;
  private shiftPressed: boolean = false;
  public oeOptionsList: { id: number, name: string }[] = [];

  /** Shift keypress detection  */
  @HostListener('document:keydown', ['$event'])
  handleKeydownEvent(event: KeyboardEvent) {
    if (event.shiftKey) {
      this.shiftPressed = true;
    }
  }

  /** Stop shift keypress detection  */
  @HostListener('document:keyup', ['$event'])
  handleKeyupEvent(event: KeyboardEvent) {
    if (!event.shiftKey) {
      this.shiftPressed = false;
    }
  }

  @HostListener('document:visibilitychange', ['$event'])
  Visibilitychange() {
    this.shiftPressed = false;
  }

  constructor(public languageService: LanguageService, private httpService: HttpService,
    private settingsService: SettingsService, private utilsService: UtilsService,
    private datePipe: DatePipe, private accountService: AccountService) { }

  ngOnInit(): void {
    this.loading = true;
    if (localStorage.getItem("recalledRows")) {
      this.itemsPerPage = parseInt(localStorage.getItem("recalledRows") || "50");
    }

    this.httpService.getOEOptionsList(1, 0).subscribe((resp) => {
      this.oeOptionsList = resp;
      this.initRecalledComponents();
    });
  }

  /** Getting recalled components list from Api endpoint */
  private initRecalledComponents(): void {
    this.selectedElements = false;
    this.selectAll = false;
    this.loading = true;
    this.recalledComponentList = [];
    const postData: any = {
      order: this.getOrderBackendName(this.order),
      direction: this.reverse ? "desc" : "asc",
      page: this.page,
      recordsPerPage: this.itemsPerPage
    };

    if (Object.keys(this.searchByList).length) {
      postData.search = this.getSearchValue();
    }

    this.httpService.getRecalledComponentList(postData).subscribe((resp: any) => {
      this.loading = false;
      if (resp.success) {
        this.recalledComponentList = resp.data.map((el: any) => {
          const componentEl: RecalledComponent = {
            SerialNumber: el.serial_number,
            ComponentName: el.kind,
            BikeId: el.bike_id,
            Recalled: true,
            LastModification: this.datePipe.transform(new Date(el.updated_at), "long") || "",
            ComponentId: el.component_id,
            OEMName: this.utilsService.getOEMName(el.component.OEM_ID, this.oeOptionsList)
          };
          return componentEl;
        });
        this.totalItems = resp.records;
      }
    }, () => { this.loading = false; });
  }

  public itemsPerPageChanged(): void {
    this.page = 1;
    this.initRecalledComponents();
    localStorage.setItem("recalledRows", this.itemsPerPage.toString());
  }

  public hasAnySearchElement(): boolean {
    return Object.keys(this.searchByList).length != 0;
  }

  private getOrderBackendName(fieldName: string) {
    if (fieldName == "SerialNumber") {
      return "serial";
    }
    if (fieldName == "ComponentId") {
      return "kind";
    }
    if (fieldName == "OEMName") {
      return "OEM_ID";
    }
    if (fieldName == "BikeId") {
      return "bike_id";
    }
    if (fieldName == "LastModification") {
      return "last_modification"
    }
    if (fieldName == "Recalled") {
      return "recalled";
    }

    return "bike_id";
  }

  private getSearchValue() {
    const searchListBackend: any = {};
    for (const [key, value] of Object.entries(this.searchByList)) {
      const searchKey = this.recalledFields.find((formFieldEl) => { return formFieldEl.FieldName == key })?.SearchName;
      if (searchKey != undefined) {
        if (searchKey == "last_modification") {
          const startEndDateArray = (value as string).split(' - ');
          searchListBackend.start_date = startEndDateArray[0].replaceAll("/", "-") + " 00:00:00";
          searchListBackend.end_date = startEndDateArray[1].replaceAll("/", "-") + " 23:59:59";
        }
        else {
          searchListBackend[searchKey] = value;
        }
      }
    }
    return searchListBackend;
  }

  public searchTypeChanged() {
    this.searchReloadTrigger();
  }

  public searchValueChanged() {
    this.searchReloadTrigger();
  }

  public clearSearch() {
    this.componentSearch = "";
    this.page = 1;
    this.initRecalledComponents();
  }

  private searchReloadTrigger() {
    if (this.typeTimeoutRef) {
      clearTimeout(this.typeTimeoutRef);
    }

    this.typeTimeoutRef = setTimeout(() => {
      this.page = 1;
      this.initRecalledComponents();
    }, 1500);
  }

  /** Changing table ordering by selected field */
  public setOrder(value: string, groupBy: boolean) {
    if (groupBy) {
      if (this.order === value) {
        this.reverse = !this.reverse;
      }

      this.order = value;
      this.initRecalledComponents();
    }
  }

  /** Returns component class name by id */
  public getComponentClass(id: number): string {
    return this.componentClassOptionsList.find((el) => { return el.id == id })?.name as string;
  }

  public lastSelectedComponentId = -1;

  /** Multiple bike id selection by pressing shift key */
  shiftSelectComponentId(event: MatCheckboxChange, index: number): void {
    if (this.shiftPressed && this.lastSelectedComponentId != -1) {

      if (index < this.lastSelectedComponentId) {
        for (let i = this.lastSelectedComponentId; i > index; i--) {
          this.recalledComponentList[i].checked = event.checked;
        }
      }
      if (index > this.lastSelectedComponentId) {
        for (let i = this.lastSelectedComponentId; i < index; i++) {
          this.recalledComponentList[i].checked = event.checked;
        }
      }
    }
    this.lastSelectedComponentId = index;

    this.checkSelectedArray();
  }

  private checkSelectedArray(): void {
    this.markAsUnrecalled = true;
    this.selectedElements = false;
    this.selectAll = true;

    this.recalledComponentList.forEach((el) => {
      if (el.checked) {
        this.selectedElements = true;
        if (el.Recalled == false) {
          this.markAsUnrecalled = false;
        }
      }
      else {
        this.selectAll = false;
      }
    });
  }

  public selectAllStateChanged(): void {
    this.recalledComponentList.forEach((el) => {
      el.checked = this.selectAll;
    });

    this.checkSelectedArray();
  }

  public markSelectedAsRecalledClick(): void {
    this.httpService.recalledBulkUpload(this.getSelectedIds(), "1").subscribe((resp: any) => {
      this.handleResponse(resp);
    });
  }

  public markSelectedAsUnrecalledClick(): void {
    this.httpService.recalledBulkUpload(this.getSelectedIds(), "0").subscribe((resp: any) => {
      this.handleResponse(resp);
    });
  }

  private getSelectedIds() {
    return this.recalledComponentList.filter((el) => {
      return el.checked;
    }).map((el) => {
      return el.SerialNumber
    });
  }

  public hasComponentSetRecalledFlagRole() {
    return this.accountService.hasComponentSetRecalledFlagRole();
  }

  private handleResponse(resp: any) {
    if (resp?.success) {
      this.initRecalledComponents();
    }
  }

  public onPageChangeEvent(event: number) {
    if (event != this.page) {
      this.page = event;
      this.initRecalledComponents();
    }
  }

  public getPaginationText(): string {
    return this.utilsService.getPaginationText(this.itemsPerPage, this.page, this.totalItems);
  }

  public onSearchListChange(newSearchList: any): void {
    this.searchByList = newSearchList;
    this.initRecalledComponents();
  }
}